export default __webpack_public_path__ + "static/char-38-67782876e03baff61dceabeae78be2a8.gif";